const setImportSheetModalState = (state, payload) => {
  state.openModalImportSheet = payload
}

const setGenerateFromDocModalState = (state, payload) => {
  state.isGenerateFromDocModalVisible = payload
}

const setAIRequestLimitModalState = (state, payload) => {
  state.isAIRequestLimitModalVisible = payload
}

export default {
  setImportSheetModalState,
  setGenerateFromDocModalState,
  setAIRequestLimitModalState,
}
